<div class="full-page">
  <!--main contents area starts here -->
  <router-outlet></router-outlet>
  <!--main content area (except header,footer) ends -->
</div>
